import { Link } from 'react-router-dom'
import { MdErrorOutline } from 'react-icons/md'

const InvalidLinkMessage = () => {
  return (
    <div className="invalid-link-overlay">
      <div className="invalid-link-card">
        <div className="invalid-link-icon">
          <MdErrorOutline style={{fontSize: '4rem', color: '#d32f2f'}} />
        </div>
        <p className="invalid-link-title">Link Expired or Invalid</p>
        <p className="invalid-link-desc">
          Your password reset link is <strong>no longer valid</strong>.<br />Please request a new one below.
        </p>
        <Link to="/forgot-password" className="invalid-link-btn">
          <p className='invalid-btn-text'>Request New Reset Link</p>
        </Link>
      </div>
    </div>
  )
}
export default InvalidLinkMessage